export default __webpack_public_path__ + "static/media/martin-knize.8869799e.jpg";